import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { AdsListLayer } from "../components/ads/AdsListLayer";

export const AdsListPage = () => {
  return (
    <MasterLayout>
      <AdsListLayer />
    </MasterLayout>
  );
};
